import { Fragment } from 'react'

import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'
import { CoursePageHeaderProps } from '~/bootcamp/types/bootcamp.types'
import { Link } from '~/components/Link'
import SVGImage from '~/components/Image/SVGImage'
import { useAppSelector } from '~/redux/hooks'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'

const PageHeader = ({
  path,
  title,
  isCollapsed,
  isExpanded,
  isCompleted,
  onClick,
}: CoursePageHeaderProps): React.ReactElement => {
  const topicColorClasses = useAppSelector(selectVideoTopicColor)

  const className = `cursor-pointer w-full relative z-0 p-2.5 flex items-center min-h-16 ${
    isCompleted
      ? `bg-purple-darker text-white border-2 hover:text-purple ${isExpanded && !isCollapsed ? 'rounded-t' : 'rounded'}`
      : `bg-white ${topicColorClasses.textClass} rounded-t`
  } lg:hover:bg-purple-midnight transition-color duration-500`

  const titleClass = `text-xl font-bold flex-1 mx-4 drop-shadow-lg ${!isCompleted && 'ml-14'}`
  const heading = (
    <Fragment>
      {isCompleted && <SVGImage height={34} srcKey="bootcamp/checkmark-white-border.svg" width={34} />}
      <span className={titleClass}>{title}</span>
      <span
        className={`transform transition-transform duration-300 ${
          isExpanded && !isCollapsed ? 'rotate-90' : 'rotate-0'
        }`}
      >
        <SVGIcon icon={ChevronRightIcon} pathClassName={isCompleted ? 'text-white' : topicColorClasses.textClass} />
      </span>
    </Fragment>
  )

  // Remove link for selected page
  if (isExpanded) {
    return (
      <div className={className} onClick={onClick}>
        {heading}
      </div>
    )
  }

  return (
    <Link className={className} onClick={onClick} scroll={false} to={path}>
      {heading}
    </Link>
  )
}

export default PageHeader
